/* global window, App */
import { CONTAINER_OPTIONS, CONTAINER_PREF } from '../../common/containers';
import { SPACING_OPTIONS, SPACING_PREF } from '../../common/spacings';

/* eslint-disable-next-line no-unused-vars */
const bd = window.bd;
/* eslint-disable-next-line no-unused-vars */
const be = window.be;
/* eslint-disable-next-line no-unused-vars */
const b$ = window.b$;

class CxpWidget {
    constructor(widget) {
        this.widget = widget;
        this.widgetName = widget.id.replace(/-\d+$/, '');

        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
    }

    addHelpTexts(propertyKeyTextMap) {
        const map = Object.keys(propertyKeyTextMap).reduce((map, key) => {
            map[key] = { text: propertyKeyTextMap[key] };
            return map;
        }, {});
        this.widget.helpTexts = map;
    }

    onPreferencesSave(event) {
        // override
    }

    isManageable() {
        const isMasterpage =
            be && be.utils
                ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage']
                : false;
        const isInCxpMode = bd.designMode; //Changed be.cmis
        const isManageable =
            isInCxpMode &&
            (isMasterpage ||
                (this.widget.model.manageable === 'true' ||
                    this.widget.model.manageable === '' ||
                    this.widget.model.manageable === undefined));
        return isManageable;
    }

    canEditContent() {
        /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
        *  you're admin or the creator? Need to check, else change the role here.
        *  */
        return (
            this.isManageable() &&
            be.ice.controller &&
            /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile)
        );
    }

    prepareCxpPreferences() {
        this.widget.addEventListener('preferences-form', event => {
            this._populatePreferencesForm(event);
            //*changed
            if (this.onCxpPreferencesForm) {
                const observer = new MutationObserver(mutations => {
                    const prefForm = document.querySelector('#PreferenceEditorContent');
                    if (prefForm) {
                        observer.disconnect();
                        this.onCxpPreferencesForm(prefForm);
                    }
                });
                observer.observe(document, { attributes: true, childList: true, subtree: true });
            }
        });
        this.widget.addEventListener('preferencesSaved', event => {
            this.widget.refreshHTML();
        });
        this.widget.addEventListener('savePreferenceForm', event => {
            this.onPreferencesSave(event);
        });
    }

    _populatePreferencesForm(event) {
        const aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
        for (let i = aPrefs.length - 1; i >= 0; i--) {
            const preferenceItem = aPrefs[i];
            const prefKey = preferenceItem.name;
            
            switch (prefKey) {
                case SPACING_PREF:
                    this._populateOptions(preferenceItem, SPACING_OPTIONS);
                    break;
                case CONTAINER_PREF:
                    this._populateOptions(preferenceItem, CONTAINER_OPTIONS);
                    break;
                default:
                    this._populateListItems(preferenceItem);
            }
        }
    }

    _populateOptions(preferenceItem, options) {
        preferenceItem.inputType.options = options.map(spacing => ({
            label: spacing.label,
            value: spacing.value,
        }));
    }

    _populateListItems(preferenceItem) {
        const prefKey = preferenceItem.name;
        const sTemplateVariants = this.widget.getPreference(`${prefKey}List`);
        
        if (!sTemplateVariants) {
            return;
        }

        const arr = sTemplateVariants.split(',');
        for (let j = 0, k = 0; j < arr.length; j++, k++) {
            preferenceItem.inputType.options[k] = {
                label: arr[j].trim(),
                value: arr[j + 1].trim(),
            };
            j++;
        }
    }

    disableClickOnDevelop(event) {
        if (App.Portal.isInDesignMode()) {
            this.widget.body.querySelectorAll('a').forEach(function(a) {
                a.addEventListener('click', e => e.preventDefault());
            });
        }
    }
}

export default CxpWidget;


// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/abstract/cxp-config.js